// extracted by mini-css-extract-plugin
export default {"productGallery":"kH-z","inQuickShop":"lH-z"};